import styled from "styled-components";

export const TimerControllerStatusWrapper = styled.div`
  border-radius: 20px;
  background: #2e2e2e;
  padding: 20px 32px;
  display: flex;
  flex-direction: column;
  min-height: 620px;
  width: 100%;
  max-width: 1587px;
  min-width: 0;
  box-sizing: border-box;
`;

export const TimerControllerStatusHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: -32px;
  border-bottom: 1px solid #4a4a5e;
  padding: 0 32px 30px;
  gap: 40px;
`;

export const TimerControllerStatusHeaderTitle = styled.div`
  display: flex;
  gap: 12px;
  color: #fff;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  align-items: center;
  flex: 1;

  > .input {
    display: flex;
    align-items: center;
    height: 40px;
    max-width: 1100px;
    flex: 1;
    padding: 8px 12px;
    box-sizing: border-box;
    border-radius: 10px;
    border: 1px solid #4a4a5e;
    background: #1a1a2e;
    position: relative;

    > img {
      cursor: pointer;
    }

    > input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      color: #fff;
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
    }
  }

  > img {
    cursor: pointer;
  }
`;

export const TimerControllerStatusHeaderButton = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */

  > div {
    display: flex;
    height: 40px;
    padding: 0 12px;
    align-items: center;
    gap: 8px;
    border-radius: 10px;
    border: 1px solid #4a4a5e;
    background: #1a1a2e;
    cursor: pointer;
  }

  > .save {
    border: none;
    background: #6436e7;
  }
`;

export const TimerControllerStatusDropBox = styled.div`
  position: absolute;
  top: 45px;
  left: 0;
  width: 100%;
  height: auto;
  background: #1a1a2e;
  border: 1px solid #4a4a5e;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  > .item {
    height: 40px;
    cursor: pointer;
    padding: 0 12px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #4a4a5e;

    &:last-child {
      border-bottom: none;
    }
  }
`;

export const TimerControllerStatusContent = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  padding-top: 20px;
  flex: 1;

  > div {
    flex: 1;
  }
`;

export const TimerControllerInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const TimerControllerPreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
`;

export const TimerControllerItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  &:has(textarea) {
    flex: 1;
  }

  > .title {
    color: #fff;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    display: flex;
    align-items: center;
    justify-content: space-between;

    > span {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
      color: #99a1af;
      font-size: 12px;
    }
  }

  > textarea {
    display: flex;
    flex: 1;
    box-sizing: border-box;
    width: 100%;
    min-height: 312px;
    padding: 8px 12px;
    align-items: flex-start;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #4a4a5e;
    background: #1a1a2e;
    color: #fff;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 16.8px */
    resize: none;
    outline: none;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  > textarea::-webkit-scrollbar {
    display: none;
  }

  > .button {
    display: flex;
    height: 36px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: 10px;
    background: #6436e7;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    cursor: pointer;
  }
`;

export const TimerControllerVariableWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  > .item {
    display: flex;
    align-items: center;
    height: 26px;
    padding: 4px 8px;
    border-radius: 33554400px;
    border: 1px solid #4a4a5e;
    background: #1a1a2e;
    color: #d1d5dc;
    text-align: center;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 133.333% */
    cursor: pointer;
  }
`;

export const TimerControllerNote = styled.div<{ $warning: boolean }>`
  width: 100%;
  color: ${({ $warning }) => ($warning ? "#FF6467" : "#05DF72")};
  background: ${({ $warning }) => ($warning ? "#82181A33" : "#0D542B33")};
  border: 1px solid ${({ $warning }) => ($warning ? "#C1000780" : "#00823680")};
  border-radius: 10px;
  display: flex;
  height: 36px;
  padding: 9px;
  box-sizing: border-box;
  align-items: center;
  gap: 8px;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
`;
